<template>
  <div class="total">
    <tips class="total-tip">
      <div class="total-tip__line"> 1. 由于亚马逊多店铺管理系统中的不同店铺的商品可能来源于同一个“ID/型号”的产品；因此“总库存量”可以理解为来源于“该ID/型号的产品”的亚马逊商品作为信息单元，汇总其不同状态下(生产中，国内中转仓仓储中，国际运输中，亚马逊仓仓储中)的总数量； </div>
      <div class="total-tip__line"> 2. 以上同一“ID/型号”的产品还包括“亚马逊商品”及“非亚马逊产品”(“非亚马逊产品”指储备的产品，还未决定作为哪个亚马逊店铺的商品)；因此，“该ID/型号的产品”的总库存量包括“亚马逊商品的库存量”及“非亚马逊产品的库存量”； </div>
    </tips>
    <div class="total-top">
      <div class="total-top__name">产品/商品总库存量</div>
      <div class="total-top__fun">
        <div class="total-top-item">
          <div class="total-top-item__name">国家站点:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="total-top-item total-top-item--input">
          <el-input size="mini" placeholder="请输入产品名称,型号等"></el-input>
        </div>
        <div class="total-top__btn">搜索</div>
      </div>
    </div>
    <div class="total-table">
      <Table :head="TableHead" height="550" width="1654"></Table>
    </div>
  </div>
</template>

<script>
import { StockStatusSearchData, StockStatusNewMoodule } from './class'
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'totalInventory',
  components: {
    Table, tips
  },
  data(){
    return {
      searchData: new StockStatusSearchData(),
      TableHead: StockStatusNewMoodule.NEWTOTALTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.total{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 250px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
